import { Platform } from 'react-native';
import * as types from './types';
import { CALL_API } from '../middleware/api';
export const getBanks = () => ({
    [CALL_API]: {
        endpoint: '/banks?types[]=BANK&types[]=BANK_NOT_SUPPORTED' +
            '&types[]=CREDIT_CARD&types[]=WALLET&types[]=CRYPTO_EXCHANGE' +
            '&types[]=CRYPTO_WALLET&types[]=PENSION&types[]=INVESTMENT' +
            '&login_types[]=OAUTH2&login_types[]=NONE&login_types[]=APIKEY' +
            '&login_types[]=NOT_SUPPORTED' +
            '&login_types[]=PLAID_LINK&withChildEntries=true' +
            '&hasPersonalBanking=true&hasBusinessBanking=true',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        types: [types.BANKS_REQUEST, types.BANKS_SUCCESS, types.BANKS_FAILURE],
    },
});
export const loginWithCredentials = (id, body, muteAlert = false) => ({
    [CALL_API]: {
        endpoint: `/banks/${id}/login-with-credentials`,
        method: 'POST',
        body: JSON.stringify(body),
        muteAlert,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            types.LOGIN_BANK_REQUEST,
            types.LOGIN_BANK_SUCCESS,
            types.LOGIN_BANK_FAILURE,
        ],
    },
});
export const getPlaidLink = (business, isLoggedIn) => ({
    [CALL_API]: {
        // Using Platform.OS gets us a link to the native plaid SDK
        // We used to use 'web' here and open a webview
        endpoint: `/plaid/link?platform=${Platform.OS}${business ? '&business=true' : ''}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        extra: { isLoggedIn },
        types: [
            types.PLAID_LINK_REQUEST,
            types.PLAID_LINK_SUCCESS,
            types.PLAID_LINK_FAILURE,
        ],
        muteAlert: false,
    },
});
export const linkPlaidConnection = (data) => async (dispatch, getState) => {
    const { linkBank } = getState();
    if (!linkBank) {
        return false;
    }
    const { plaid_details } = linkBank;
    if (!plaid_details) {
        return false;
    }
    const { state } = plaid_details;
    const body = { ...data, state };
    return dispatch({
        [CALL_API]: {
            endpoint: '/plaid/redirect',
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: [
                types.LINK_PLAID_CONNECTION_REQUEST,
                types.LINK_PLAID_CONNECTION_SUCCESS,
                types.LINK_PLAID_CONNECTION_FAILURE,
            ],
        },
    });
};
export const getLinkToBank = (bankId, isLoggedIn) => ({
    [CALL_API]: {
        endpoint: `/banks/${bankId}/auth-link?supportAppLink=true`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        extra: { bankId, isLoggedIn },
        types: [types.LINK_REQUEST, types.LINK_SUCCESS, types.LINK_FAILURE],
        muteAlert: false,
    },
});
export const getRenewAuth = (id, isLoggedIn, connection) => ({
    [CALL_API]: {
        // Using Platform.OS gets us a link to the native plaid SDK
        // We used to use 'web' here and open a webview
        endpoint: `/bank-connections/${id}/renew-auth?supportAppLink=true&platform=${Platform.OS}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        extra: { connection, isLoggedIn },
        types: [types.LINK_REQUEST, types.LINK_SUCCESS, types.LINK_FAILURE],
        muteAlert: false,
    },
});
export const listProviderAccounts = (connection) => {
    const previousAccountIds = connection.accounts.map((account) => account.id);
    return {
        [CALL_API]: {
            endpoint: `/bank-connections/${connection.id}/list-ob-accounts`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ previousAccountIds }),
            extra: { connectionId: connection.id },
            types: [
                types.LIST_PROVIDER_ACCOUNTS_REQUEST,
                types.LIST_PROVIDER_ACCOUNTS_SUCCESS,
                types.LIST_PROVIDER_ACCOUNTS_FAILURE,
            ],
            muteAlert: true,
        },
    };
};
export function moveImportedAccounts(accountProviderIds, bankConnectionId) {
    return {
        [CALL_API]: {
            endpoint: `/bank-connections/${bankConnectionId}/move-ob-accounts`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ accountProviderIds }),
            extra: { accountProviderIds, bankConnectionId },
            muteAlert: true,
            types: [
                types.NEW_ACCOUNTS_MOVE_SPACE_REQUEST,
                types.NEW_ACCOUNTS_MOVE_SPACE_SUCCESS,
                types.NEW_ACCOUNTS_MOVE_SPACE_FAILURE,
            ],
        },
    };
}
export const resetAccountsMoveSpace = () => ({ type: types.RESET_ACCOUNTS_MOVE_SPACE });
export const resetRenewingConnection = () => ({ type: types.RESET_RENEWING_CONNECTION });
export const clearSyncingAccounts = (connectionId) => ({
    type: types.CLEAR_SYNCING_ACCOUNTS,
    payload: { connectionId },
});
export const setLinkingConnection = (connection) => ({
    type: types.SET_LINKING_CONNECTION,
    payload: { connection },
});
export const resetLinkingConnection = () => ({ type: types.RESET_LINKING_CONNECTION });
export const setInstalledBankAppsAction = (banks) => ({
    banks,
    type: types.SET_INSTALLED_BANK_APPS,
});
